import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Context } from "../../context/Context";
import { toast } from "react-toastify";
import "./edit.css";
import { jwtDecode } from "jwt-decode";

const UnauthorizedComponent = () => (
  <div style={{ textAlign: "center", paddingTop: "100px", fontSize: "18px" }}>
    Not Authorized!
  </div>
);

const SECTIONS = [
  { title: "Ideation", color: "#FFEA00" },         // Neon Yellow
  { title: "Finalized Topics", color: "#FFC400" }, // Vivid Amber
  { title: "First Draft", color: "#FFA500" },      // Bright Orange
  { title: "Structural Edit", color: "#FF9100" },  // Deep Orange
  { title: "Second Draft", color: "#FF3D00" },     // Blazing Red-Orange
  { title: "Copy Edit", color: "#FF0080" },        // Shocking Pink
  { title: "Final Draft", color: "#D500F9" },      // Electric Purple
  { title: "Proofread", color: "#651FFF" },        // Intense Indigo
  { title: "Upload", color: "#2979FF" },           // Vivid Blue
  { title: "Review", color: "#00E5FF" },           // Bright Cyan
  { title: "Schedule/Publish", color: "#00E676" }, // Lush Lime Green
  { title: "Share/Promote", color: "#76FF03" },    // Neon Green
];

const ArticleRow = ({ color }) => (
  <div className="article-row">
    <div className="dot" style={{ backgroundColor: color }}></div>
    <span className="article-title">Lorem ipsum</span>
    <div className="xmark">✖</div>
    <div className="xmark">✖</div>
    <select className="genre-select">
      <option>Lorem ipsum</option>
    </select>
  </div>
);

export default function Collab() {
  const { user, token } = useContext(Context);
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(null);

  useEffect(() => {
    if (!user || !token) {
      navigate("/login");
    }

    try {
      const userRole = Number(jwtDecode(token)?.role);
      setIsAuthorized(userRole > 3);
    } catch (err) {
      console.error("Invalid token", err);
      setIsAuthorized(false);
    }
  }, [user, token, navigate]);

  if (!isAuthorized) {
    return <UnauthorizedComponent />;
  }

  return (
   <>
    <div className="Edit">
      <div className="edit">
        <div
          className="write-title"
          style={{ position: "relative", display: "flex", alignItems: "center", gap: "40px" }}
        >
          <p
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              margin: 0,
            }}
          >
            Editorial Dashboard
          </p>
        </div>
        <div className="edit-body">
          {SECTIONS.map(({ title, color, items }) => (
            <div key={title} className="edit-section">
              <div className="edit-section-header">
                <span className="edit-section-dot" style={{ backgroundColor: color }}></span>
                <span className="edit-section-title">{title}</span>
                <span className="edit-section-chevron">⌃</span>
              </div>
              <div className="edit-section-card">
                {[...Array(3)].map((_, i) => (
                  <ArticleRow key={i} color={color} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
   </>
  );
}
